module.exports = __webpack_public_path__ + "img/sonac_mobile.2cc0b47c.jpg";